module.exports = __webpack_public_path__ + "static/media/default_social_object.40c8d77f.svg";